module.exports = __webpack_public_path__ + "6fb2e849a88249054a138ceec1917ce0.svg";